/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_EventInputs */

const th_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างรายการแข่งขัน`)
};

const en_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create event`)
};

const ja_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大会を作成`)
};

const zh_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建赛事`)
};

const es_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear evento`)
};

const pt_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar evento`)
};

const id_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat acara`)
};

const fr_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un événement`)
};

const tl_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gumawa ng event`)
};

const vi_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo sự kiện`)
};

const ko_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트 만들기`)
};

const de_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event anlegen`)
};

const ru_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать событие`)
};

const tr_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlik oluştur`)
};

const it_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea evento`)
};

const pl_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utwórz wydarzenie`)
};

const uk_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Створити подію`)
};

const hi_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयोजन बनाएँ`)
};

const ar_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إنشاء فعالية`)
};

const ms_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cipta acara`)
};

const bn_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আয়োজন তৈরি করুন`)
};

const zh_tw2_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建立賽事`)
};

const zh_hk2_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建立賽事`)
};

const ur_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ایونٹ بنائیں`)
};

const fa_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ساختن رویداد`)
};

const sw_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fungua tukio`)
};

const nl_create_event = /** @type {(inputs: Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenement aanmaken`)
};

/**
* | output |
* | --- |
* | "Create event" |
*
* @param {Create_EventInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const create_event = /** @type {((inputs?: Create_EventInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_EventInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_create_event(inputs)
	if (locale === "ja") return ja_create_event(inputs)
	if (locale === "zh") return zh_create_event(inputs)
	if (locale === "es") return es_create_event(inputs)
	if (locale === "pt") return pt_create_event(inputs)
	if (locale === "id") return id_create_event(inputs)
	if (locale === "fr") return fr_create_event(inputs)
	if (locale === "tl") return tl_create_event(inputs)
	if (locale === "vi") return vi_create_event(inputs)
	if (locale === "ko") return ko_create_event(inputs)
	if (locale === "de") return de_create_event(inputs)
	if (locale === "ru") return ru_create_event(inputs)
	if (locale === "tr") return tr_create_event(inputs)
	if (locale === "it") return it_create_event(inputs)
	if (locale === "pl") return pl_create_event(inputs)
	if (locale === "uk") return uk_create_event(inputs)
	if (locale === "hi") return hi_create_event(inputs)
	if (locale === "ar") return ar_create_event(inputs)
	if (locale === "ms") return ms_create_event(inputs)
	if (locale === "bn") return bn_create_event(inputs)
	if (locale === "zh-TW") return zh_tw2_create_event(inputs)
	if (locale === "zh-HK") return zh_hk2_create_event(inputs)
	if (locale === "ur") return ur_create_event(inputs)
	if (locale === "fa") return fa_create_event(inputs)
	if (locale === "sw") return sw_create_event(inputs)
	if (locale === "nl") return nl_create_event(inputs)
	return en_create_event(inputs)
});